import { render, staticRenderFns } from "./FOSection.vue?vue&type=template&id=ccf047aa&"
import script from "./FOSection.vue?vue&type=script&lang=js&"
export * from "./FOSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports